"use client";

import { useGetCart } from "@/fetcher/useGetCart";
import { NAVIGATION_SCREENS, useNavigation } from "@/hooks/useNavigation";
import classNames from "classnames";
import { CustomImage as Image } from "../Image/CustomImage";
import { usePathname } from "next/navigation";
import React, { useEffect, useState } from "react";
import useTranslations from "@/hooks/useTranslations";

export const BottomNavigator = () => {
  const { translations } = useTranslations();
  const NAVIGATION_LIST = [
    {
      id: "home",
      label: translations.navigation?.home,
    },
    {
      id: "limited",
      label: translations.navigation?.limitedOffer,
    },
    {
      id: "cart",
      label: translations.navigation?.cart,
    },
    {
      id: "mypage",
      label: translations.navigation?.mypage,
    },
  ];
  const pathname = usePathname();
  const { navigationTo } = useNavigation();
  const [navigation, setNavigation] =
    useState<(typeof NAVIGATION_LIST)[number]["id"]>("home");

  const { data } = useGetCart();

  useEffect(() => {
    if (pathname != null)
      setNavigation(pathname.split("/")[2]?.toLocaleLowerCase() || "home");
  }, [pathname]);

  const onClickBottomNavigation = (id: string) => () => {
    setNavigation(id);
    navigationTo(id.toUpperCase() as NAVIGATION_SCREENS);
  };

  return (
    <div className="flex w-full px-[16px] pb-[20px] border-t-[0.5px] border-[#A3A3A3] fixed bottom-0 bg-[#FAF7F4] max-w-[530px]">
      {NAVIGATION_LIST.map(({ id, label }, ix) => (
        <div
          onClick={onClickBottomNavigation(id)}
          className="flex-1 flex items-center justify-center flex-col cursor-pointer relative"
          key={id + "-" + ix}
        >
          <Image
            src={`/assets/bottom/${id}.svg`}
            width={32}
            height={32}
            alt="bottom-tab-icon"
            className={classNames(
              "[&>path]:fill-[#262626]",
              navigation === id ? "" : "opacity-[0.2]"
            )}
          />
          <span
            className={classNames(
              "text-[9px] text-[#262626]",
              navigation === id ? "" : "opacity-[0.7]"
            )}
          >
            {label}
          </span>
          {id === "cart" && (
              <div className="bg-[#E00000] rounded-full w-[14px] h-[14px] text-[9px] text-white flex items-center justify-center absolute top-[2px] right-[30%]">
              {data?.totalList || 0}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
